import React from "react";
import s from "./Label.module.scss";
import { Box, Typography } from "@mui/material";
import useColors from "utils/useColors/useColors";

/**
 * @param {Object} props
 * @param {string} props.label
 * @param {string} [props.subLabel]
 * @param {boolean} [props.mandatory = false] - enable mandatory symbol
 * @param {boolean} [props.noBottomMargin = false] - disable bottom margin
 * @param {boolean} [props.empty = false] - remove the label while keeping the padding
 */
const Label = ({ label, subLabel, mandatory = false, noBottomMargin = false, empty }) => {
  const c = useColors();

  return (
    <div className={[s.inputLabel, noBottomMargin && s.noMarginBottom].filter(Boolean).join(" ")}>
      {
        empty ? (
          // Simulate the height of the label
          <Box sx={{ height: "18px", mb: 0.5 }} />
        ) : (
          <>
            <Typography variant="content-s">{label}</Typography>
            {!!mandatory && (
              <Typography variant="content-s" color={c.danger}>&nbsp;*</Typography>
            )}
            {!!subLabel && <>
              <br />
              <Typography variant="content-xs">{subLabel}</Typography>
            </>}
          </>
        )
      }
    </div>
  );
};

export default React.memo(Label);
